import React from 'react';
import { ImportDialog } from '../../../components/common';
import { disabilityService } from '../../../services/disabilityService';

interface DisabilitiesImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImportComplete: () => void;
}

const DisabilitiesImportDialog: React.FC<DisabilitiesImportDialogProps> = ({
  open,
  onClose,
  onImportComplete,
}) => (
  <ImportDialog
    open={open}
    onClose={onClose}
    onImportComplete={onImportComplete}
    title="Importar Deficiências PCD"
    description="Selecione um arquivo Excel (.xlsx) com as deficiências PCD para importar. Registros duplicados serão ignorados."
    templateFileName="template-importacao-deficiencias.xlsx"
    onDownloadTemplate={() => disabilityService.downloadTemplate()}
    onImport={(file) => disabilityService.importDisabilities(file)}
    entityLabel="registro(s)"
  />
);

export default DisabilitiesImportDialog;
